<template>
  <section class="viewsrhqyComplaint_Detail p-4 space-y-4">
    <viewTitle title="业务管理 / 投诉建议详情" :showReturn="true">
      <template slot="return">
        <el-button
          v-if="detail.handler_state === 1"
          class="w-20"
          size="small"
          type="primary"
          @click="onHander"
          v-has="['c-complaint-list-handle']"
          >处理</el-button
        >
        <el-button v-has="['c-complaint-list-delete']" @click="onDelete" class="w-20" size="small" type="danger">删除</el-button>
        <el-button
          class="w-20"
          @click="$router.go(-1)"
          plain
          size="small"
          style="font-size: 14px;"
          >返回</el-button
        >
      </template>
    </viewTitle>
    <div class="text-right">
      运行状态：{{ detail.handler_state === 1 ? "未处理" : "已处理" }}
    </div>
    <el-descriptions
      :labelStyle="{ width: '10%', textAlign: 'center' }"
      :column="4"
      border
    >
      <div class="space-x-10" slot="title">
        <span>申请人：{{ detail.user_name }}</span>
        <span>所属基地：{{ detail.company_name }}</span>
        <span>申请时间：{{ detail.create_time | timeFormat }}</span>
      </div>
      <el-descriptions-item :span="2" label="投诉建议" :contentStyle="{ width: '60%' }">
        <span style="word-break: break-all;">{{ detail.description }}</span>
      </el-descriptions-item>
      <el-descriptions-item :span="2" label="图片" :contentStyle="{ width: '20%' }">
        <div
          class="flex flex-wrap items-start space-x-2"
          
        >
          <el-image v-for="item in detail.complaint_files"
          :key="item.id"
            style="width: 50px; height: 50px"
            :src="item.real_path"
            :preview-src-list="complaintPerviewSrcList"
            fit="fill"
          ></el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      v-if="detail.handler_id"
      :labelStyle="{ width: '200px' }"
      title="处理信息"
      direction="vertical"
      :column="5"
      border
    >
      <el-descriptions-item label="处理人" :span="1">{{
        detail.handler_name
      }}</el-descriptions-item>
      <el-descriptions-item label="处理时间" :span="1">{{
        detail.handler_time | timeFormat
      }}</el-descriptions-item>
      <el-descriptions-item label="处理备注" :span="2">{{
        detail.handler_content
      }}</el-descriptions-item>
      <el-descriptions-item label="处理图片" :span="1" :contentStyle="{ width: '250px' }">
        <div
          class="flex flex-wrap items-start space-x-2"
          
        >
          <el-image v-for="item in detail.handler_files"
          :key="item.id"
            style="width: 50px; height: 50px"
            :src="item.real_path"
            :preview-src-list="handlerPerviewSrcList"
            fit="fill"
          ></el-image>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <ComplaintHandle ref="ComplaintHandle" @ok="getDetail"/>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import ComplaintHandle from './components/ComplaintHandle.vue';
export default {
  props: [""],

  data() {
    return {
      detail: {}
    };
  },

  computed: {
    ...mapGetters(["baseInfo"]),
    complaintPerviewSrcList() {
      return this.detail.complaint_files.map(item => item.real_path);
    },
    handlerPerviewSrcList() {
      return this.detail.handler_files.map(item => item.real_path);
    }
  },

  watch: {},

  components: {
    ComplaintHandle
  },

  mixins: [],

  beforeCreate() {},

  created() {
    this.getDetail();
  },

  filters: {
    timeFormat(time, style = "YYYY-MM-DD HH:mm:ss") {
      return time ? moment.unix(time).format(style) : "--";
    }
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    async getDetail() {
      try {
        const res = await this.$common.http({
          url: "/api/queue/admin/detail_complaint",
          data: {
            id: this.$route.params.id
          }
        });
        this.detail = res.data.data;
      } catch (error) {}
    },
    onDelete() {
      this.$confirm("确认删除？删除后数据将不可恢复！", "删除")
        .then(async () => {
          this.$common
            .http({
              url: "/api/queue/admin/delete_complaint",
              data: {
                id: this.detail.id
              }
            })
            .then(() => {
              this.$common.pcToastSuccess(`操作成功`);
              this.$router.go(-1);
            });
        })
        .catch(_ => {});
    },
    onHander() {
      this.$refs.ComplaintHandle.onOpen(this.detail);
    }
  }
};
</script>
